import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';


import { MyApp } from './app.component';
import { ConfigApp } from "../providers/config.app";
import { ToastService } from "../services/toast-service";
import { ServerService } from "../services/server-service";
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from "@angular/http";
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { IonicSelectableModule } from 'ionic-selectable';

import { DatePicker } from '@ionic-native/date-picker';



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    // NgCalendarModule,
    IonicSelectableModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: 'חזרה',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
      monthNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      monthShortNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
      dayShortNames: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'שבת'],
    }),
    NgxSkeletonLoaderModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TabsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ConfigApp,
    ToastService,
    ServerService,
    AppVersion,
    Network,
    InAppBrowser,
    DatePicker,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts